import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { OrgOptionProps } from '../../props/organization';
import { TextInput, TextBoxInput, SelectInput } from "./ValidationWrapper";
import { getRef, addChange } from '../../actions/changes';

import styles from './StewardAssetEditPage.scss';
import SuggestSearch from '../../components/StewardAssetEdit/SuggestSearch';
import CheckBoxInput from "../../components/StewardAssetEdit/CheckBoxInput";

const propTypes = {
  value: PropTypes.object,
  assetDetails: PropTypes.shape({
    name: PropTypes.string,
    singular: PropTypes.string,
    plural: PropTypes.string
  }),
  orgOptions: PropTypes.arrayOf(OrgOptionProps)
};

const defaultProps = {};

export class AssetTab extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      record: this.props.value,
      ref: this.props.getRef(
        this.props.assetDetails.plural,
        { id: this.props.value.id },
        -1,
        ['name', 'orgId', 'description', 'directions'].reduce((m, f) => Object.assign(m, { [f]: props.value[f] }), {})
      )
    };

    this.textInputs = this.textInputs.bind(this);
    this.selectInputs = this.selectInputs.bind(this);
    this.textBoxInputs = this.textBoxInputs.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  textInputs() {
    return [
      {
        label: `${this.props.assetDetails.name} Name`,
        required: true,
        field: 'name'
      },
      {
        label: `${this.props.assetDetails.name} ID`,
        readOnly: true,
        field: 'id'
      },
      {
        label: 'Email',
        field: 'email'
      },
      {
        label: 'Fee Description',
        field: 'feeDescription'
      },
      {
        label: 'Legacy ID',
        field: 'legacyId'
      },
      {
        label: 'Legacy ID Organization',
        field: 'orgRefId'
      },
      {
        label: 'Latitude',
        field: 'latitude'
      },
      {
        label: 'Longitude',
        field: 'longitude'
      },
      {
        label: 'Phone',
        field: 'phone'
      }
    ];
  }

  selectInputs() {
    return [
      {
        label: 'Organization',
        key: 'orgId',
        field: 'orgId',
        required: true,
        fullWidth: true,
        size: Math.max(1, (this.props.orgOptions || []).length),
        options: this.props.orgOptions || []
      }
    ];
  }

  textBoxInputs() {
    return [
      {
        label: 'Description',
        field: 'description',
        required: true,
        fullWidth: true,
        maxChar: 4000
      },
      {
        label: 'Directions',
        field: 'directions',
        required: true,
        fullWidth: true,
        maxChar: 4000
      },
      {
        label: 'Keywords',
        field: 'keywords',
        maxChar: 400
      },
      {
        label: 'Stay Limit',
        field: 'stayLimit',
        maxChar: 400
      }
    ];
  }

  handleChange(event) {
    const { dataset: { field }, value } = event.target;

    const change = { [field]: value };

    this.setState((prevState) => ({
      ...prevState,
      record: { ...prevState.record, ...change }
    }), () => this.props.addChange(this.state.ref, change));
  }

  render() {
    const { orgOptions } = this.props;
    const { record: value, ref } = this.state;

    const query = { limit: 10, assetTypes: ['recarea'], orgIds: orgOptions.map((org) => org.value) };

    return (
      <div className={styles['asset-tab']}>
        {this.textInputs().map((textInput) => (
          <TextInput
            key={textInput.field}
            changeRef={ref}
            {...textInput}
            value={get(value, textInput.field)}
            onChange={this.handleChange} />
        ))}
        {this.props.assetDetails.name !== 'Facility' ? null :
          <div className={styles['text-input']}>
            <label htmlFor="parentRecArea">Parent Rec Area</label>
            <SuggestSearch
              id="parentRecArea"
              field="recareas[0]"
              idField="recAreaId"
              value={get(value, 'recareas[0]')}
              query={query}
              placeholder="search Rec Areas by name..."
              onChange={this.handleChange} />
          </div>
        }
        <CheckBoxInput
          value={get(value, 'enabled')}
          label="Enabled"
          field="enabled"
          onChange={this.handleChange} />
        {this.selectInputs().map((selectInputProps) => (
          <SelectInput
            {...selectInputProps}
            changeRef={ref}
            onChange={this.handleChange}
            value={get(value, selectInputProps.field)} />
        ))}
        {this.textBoxInputs().map((textBoxInput) => (
          <TextBoxInput
            key={textBoxInput.field}
            changeRef={ref}
            {...textBoxInput}
            value={get(value, textBoxInput.field)}
            onChange={this.handleChange} />
        ))}
      </div>
    );
  }
}

AssetTab.propTypes = propTypes;
AssetTab.defaultProps = defaultProps;

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  getRef,
  addChange
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AssetTab);

